import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsTitleBanner } from 'wisestep-base';

import FAQOptions from './FAQOptions';

interface IJobBoard {
  children: React.ReactElement;
}

const LayoutPage = ({ children }: IJobBoard) => {
  const navigate = useNavigate();
  return (
    <Box>
      <WsTitleBanner
        title="Frequently Asked Questions"
        goBack={() => navigate('/app-settings/faqs')}
      />
      <Grid container rowGap={3}>
        <Grid item xs={3}>
          <FAQOptions />
        </Grid>
        <Grid item xs={9} pt={3}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LayoutPage;
